const STORAGE_KEY = 'infrastructureLeasingListClientId';

/**
 * Stable id for anonymous users so server can upsert the same infrastructure listing
 * (paired with listing title) without a login.
 */
export function getInfrastructureListingClientId() {
  if (typeof window === 'undefined') {
    return '';
  }
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `id_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `id_${Date.now()}`;
  }
}
